// extracted by mini-css-extract-plugin
module.exports = {"pointsAndPerks":"do","row":"eo","nextDay":"fo","refunds":"go","earnPoints":"ho","earnBig":"io","bonus":"jo","prime":"ko","asColumn":"lo"};